import { Inquiry, mibInquirySchema } from '../../../../mib';

export const getBLMIBProviderInquiriesDataSchema = mibInquirySchema;

export type GetBLMIBProviderInquiriesData = Inquiry;
